import { BaseRestDataProvider } from './BaseRestDataProvider';

export interface Settings {
  message: string;
}

export class SettingsRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/settings');
  }

  async getSettings(): Promise<Settings> {
    return this.get<Settings>('');
  }

  async resetSettings(): Promise<Settings> {
    return this.post<Settings>('/reset', {});
  }
}

export default SettingsRestDataProvider;
